import Vue from 'vue';
import toastr from 'toastr';
import moment from 'moment';

import AppHistory from '@/js/libs/AppHistory';
import appRouter from '@/js/helpers/app-router';
import Gate from '@/js/libs/Gate';
import Http from '@/js/libs/Http';
import i18n from '@/js/libs/i18n';

import '@/js/vendor';
import '@/js/components/common';

import '@/js/directives/tooltip';
import '@/js/directives/append';
import '@/js/directives/prepend';
import '@/js/directives/trim-whitespace';

import '@/js/helpers/filters';

Vue.use(appRouter);
Vue.use(Gate);
Vue.use(Http);

Vue.use({
    install: function (Vue) {
        Vue.prototype.$appHistory = new AppHistory();
        Vue.prototype.$toastr = toastr;
        Vue.prototype.$navigateTo = (to, delay = 1) => {
            if (process.env.MIX_DEBUG === true || process.env.MIX_DEBUG === 'true') {
                console.log('$navigateTo', (new Error()).stack);
            }

            setTimeout(() => {
                window.location.href = to;
            }, delay);
        };
        Vue.prototype.$forceReload = (delay = 1) => new Promise(() => {
            if (process.env.MIX_DEBUG === true || process.env.MIX_DEBUG === 'true') {
                console.log('$forceReload', (new Error()).stack);
            }

            setTimeout(() => {
                window.location.reload();
            }, delay);
        });
        Vue.prototype.$debugError = (error, ...tags) => {
            if (process.env.MIX_DEBUG === true || process.env.MIX_DEBUG === 'true') {
                console.log('$debugError', (new Error()).stack);
                console.error('[DEBUG]', tags, error);
            }
        };
    },
});

Vue.config.ignoredElements = ['trix-editor'];

const app = new Vue({
    name: 'App',

    i18n,

    data: {
        isDownload: false,
        loadingCount: 0,
        blade: window.blade || {},
    },

    computed: {
        isLoading() {
            return this.loadingCount > 0;
        },
    },

    beforeCreate() {
        this.$http.registerObserver({
            started: () => this.incrementLoadingCount(),
            ended: () => this.decrementLoadingCount(),
        });

        const locale = window.appLocale;
        moment.locale(locale === 'pt' ? 'pt-br' : locale);
    },

    beforeMount() {
        this.authenticate();
    },

    mounted() {
        this.initWindow();
        this.setCSRFToken();
    },

    methods: {
        incrementLoadingCount() {
            this.loadingCount++;
        },

        decrementLoadingCount() {
            this.isLoading && this.loadingCount--;
        },

        initWindow() {
            window.onbeforeunload = () => {
                this.incrementLoadingCount();

                const delay = this.isDownload ? 350 : 10000;
                this.isDownload = false;

                setTimeout(() => {
                    this.decrementLoadingCount();
                }, delay);
            };
        },

        setCSRFToken() {
            const token = window.document.head.querySelector('meta[name="csrf-token"]');

            if (token) {
                this.$http.setCSRFToken(token.content);
            } else {
                throw new Error('CSRF token not found');
            }
        },

        authenticate() {
            if (!this.blade.authUser) {
                return;
            }

            this.$gate.setUser(this.blade.authUser);
        },
    },
});

let init = function () {
    app.$mount('#app');
};

window.document.addEventListener('DOMContentLoaded', init);
